import useMediaQuery from './useMediaQuery';

export const MOBILE_BREAKPOINT_QUERY = '(max-width: 768px)';

export default function useMobileBreakpoint() {
  return useMediaQuery(MOBILE_BREAKPOINT_QUERY);
}
